export default __webpack_public_path__ + "static/thegoradiafoundation-4d7b5842e97f3b0c925f5925787caf43.png";